module.exports = __webpack_public_path__ + "static/media/flow01.c4b90fa9.svg";